import awsconfig from "../../aws-exports";
import {AuthUser} from "aws-amplify/auth";

export const getTokenService = ({user}:{user:AuthUser}) =>{
    return {
        token:() =>{
            return localStorage.getItem(`CognitoIdentityServiceProvider.${awsconfig.aws_user_pools_web_client_id}.${user.userId}.accessToken`)
        }
    }
}